// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ExtensionSkeleton_card__RY327 {
  position: relative;
  display: block;
  width: 100%;
  padding: 4px;
  gap: 4px;
}
.ExtensionSkeleton_card__RY327 span {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/Sidecar/ExtensionSkeleton/ExtensionSkeleton.module.scss"],"names":[],"mappings":"AAAA;EACC,kBAAA;EACG,cAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;AACJ;AAAC;EACC,WAAA;AAEF","sourcesContent":[".card {\n\tposition: relative;\n    display: block;\n    width: 100%;\n    padding: 4px;\n    gap: 4px;\n\tspan{\n\t\twidth: 100%;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `ExtensionSkeleton_card__RY327`
};
export default ___CSS_LOADER_EXPORT___;
